import { PLATFORM } from "./envConfig";

export const config = {
  deliveryOptions: {
    takeaway: "collect at store",
    deliveryAtGate: "collect at gate",
  },
  productFulfilmentType: {
    takeaway: "Takeaway",
    delivery: "Delivery",
  },
  imageType: {
    listing: "Large",
    details: "Thumbnail",
    info: "Large",
    cartBand: "Thumbnail",
    product: "Regular"
  },
  terminal: [
    { label: "Terminal1", value: "Terminal1" },
    { label: "Terminal2", value: "Terminal2" },
  ],
  sector: [
    { label: "Domestic", value: "Domestic" },
    { label: "International", value: "International" },
  ],
  movementType: [
    { label: "Departure", value: "Departure" },
    { label: "Arrival", value: "Arrival" },
  ],
  availableDelOpts: [
    { label: "Takeaway", value: "Takeaway" },
    { label: "Delivery", value: "Delivery" },
  ],
  platform: PLATFORM,
  domain: "Food and Beverages",
};

export const otpTimeout = 60;
export const resource = "paxapp";
export const resetSessionTimeout = 10000; //in milliseconds
export const delTimePerT1Store = 5; //in mins
export const delTimePerT2Store = 8; //in mins

export default config;
